import { ref } from "vue";

// Singleton state — shared across all consumers
const isOpen = ref(false);

function open() {
  isOpen.value = true;
}

function close() {
  isOpen.value = false;
}

function toggle() {
  isOpen.value = !isOpen.value;
}

function handleGlobalKeydown(e) {
  if (!e.key) return;
  const key = e.key.toLowerCase();
  const isModK = (e.metaKey || e.ctrlKey) && key === "k";
  if (isModK) {
    e.preventDefault();
    toggle();
  }
}

if (typeof window !== "undefined") {
  window.addEventListener("keydown", handleGlobalKeydown);
}

export function useCommandPalette() {
  return { isOpen, open, close, toggle };
}
